import BaseEntityService from 'vue-core/services/BaseEntityService';
import env from 'environment';

class TagService
    extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + '/tags'
    });
  }
}

const service = new TagService();

export default service;
